import { compose } from 'recompose';

import PendingControl from './pendingControl';

const enhance = compose();
export default enhance(PendingControl);
